/* eslint-disable react/prop-types */
import Styled from 'styled-components';
import React from 'react';
import { VIEWPORT_SM_MIN } from '../../util/mediaQueries';
import Tooltip from '../../molecules/Tooltip';

export const flexItemPadding = '.5em';

export const ButtonWrapper = Styled.div`
  margin:${({ withMargin }) => (withMargin ? '4px' : '0')};
  &>*{
    width:100%
  }`;

export const HorizontalLine = Styled.div`
  height:1px;
  border-top:1px solid #E5E8EA;
  width:100%
`;

export const FlexingContainer = Styled.div`
  display:flex;
  flex-direction:row;
  flex-wrap: ${({ wrapReverse }) => (wrapReverse ? 'wrap-reverse' : 'wrap')};
  & > * {
    flex:1;
  }
`;

export const Form = Styled.form`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Fieldset = Styled.fieldset`
flex: 1 1 100%;
margin: 0;
padding: ${flexItemPadding};
border: none;
`;

export const InputContainer = Styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background-color: #F8F9FA;
`;


const NewCreditContainer = Styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:space-between;
  margin-bottom:1em;
  height:53.75px;
`;

const NewCreditLabel = Styled.div`
`;
const NewCreditValue = Styled.div`
    font-weight: bold;
    color: ${props => props.theme.labelColorFocus};
`;

export const NewCreditAttribute = ({ label, value }) => (
  <NewCreditContainer>
    <NewCreditLabel>{label}</NewCreditLabel>
    <NewCreditValue>{value}</NewCreditValue>
  </NewCreditContainer>
);

const GradientTitleContainer = Styled.div`
  border-bottom: 1px solid #E5E8EA;
  width:100%;
`;

const GradientTitleGradient = Styled.div`
  color:white;
  background: linear-gradient(90deg, rgba(16,58,106,1) 0%, rgba(91,133,181,1) 100%);
  border-bottom: 1px solid #E5E8EA;
  width:50%;
  position: relative;
  padding-left:.5em;
  display:flex;
  align-items:center;
`;

const Triangle = Styled.div`
 width:0;
 height:0;
 border-top: 20px solid transparent;
 border-right:5px solid white;
 position:absolute;
 right:0;
 bottom:0;
`;

const GradientTitle = props => (
  <GradientTitleContainer>
    <GradientTitleGradient>
      {props.children}
      <Triangle />
    </GradientTitleGradient>
  </GradientTitleContainer>
);

const ComparisonContainer = Styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:space-between;
  padding: 6px;

`;
const ComparisonContainerBlock = Styled.div``;
const ComparisonOldValue = Styled.div`
  font-size: 1.25em;
  font-weight: bold;
`;
const ComparisonNewValue = Styled.div`
  font-size: 1.25em;
  font-weight: bold;
  color: ${props => props.theme.labelColorFocus};
`;

export const Comparison = ({
  title,
  oldValue,
  newValue,
  oldLabel = 'aktueller Kredit',
  newLabel = 'neuer Kredit',
  tooltipText,
}) => (
  <div>
    <GradientTitle>
      {title}
      {tooltipText && <Tooltip size={18} text={tooltipText} />}
    </GradientTitle>
    <ComparisonContainer>
      <ComparisonContainerBlock>
        <ComparisonOldValue>{oldValue}</ComparisonOldValue>
        <div>{oldLabel}</div>
      </ComparisonContainerBlock>
      <ComparisonContainerBlock>
        <ComparisonNewValue>{newValue}</ComparisonNewValue>
        <div>{newLabel}</div>
      </ComparisonContainerBlock>
    </ComparisonContainer>
  </div>
);

const SavingContainer = Styled.div`
  display:flex;
  flex-wrap:wrap;
  flex-direction:row;
  align-items: center;
  justify-content: space-between;

  color: ${props => props.theme.labelColorFocus};
  font-size: 1.45em;
  font-weight: bold;
  margin: .5em 0;
  width:100%;

  @media ${VIEWPORT_SM_MIN} {
    font-size: 1.75em;
  }
`;

const SavingLabel = Styled.div`
  flex:1;

  @media ${VIEWPORT_SM_MIN} {
    padding-right:8px;
  }
`;

const SavingValue = Styled.div`
  flex:1;
  text-align: right;

  @media ${VIEWPORT_SM_MIN} {
    padding-left: 10px;
    text-align:left;
  }
`;

export const SavingAmount = ({ value, tooltipText }) => (
  <SavingContainer>
    <SavingLabel
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      Gesamtersparnis{' '}
      <Tooltip
        size={18}
        text={tooltipText}
        style={{ margin: '0', alignSelf: 'flex-start' }}
      />
    </SavingLabel>
    <SavingValue>{value}</SavingValue>
  </SavingContainer>
);

const NewCreditAmountContainer = Styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:space-between;
  margin-bottom:.5em;
`;

export const NewCreditAmount = ({ value }) => (
  <NewCreditAmountContainer>
    <div>Abzulösender Kredit</div>
    <b>{value}</b>
  </NewCreditAmountContainer>
);


export const Title = Styled.div`
    font-size: 1.5em;
    font-weight: bold;
    line-height: 1.5em;
    margin-bottom: .5em;
    color: ${props => props.theme.labelColorFocus};
`;

export const Section = Styled.div`
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.5em;
    margin-bottom: .5em;
    color: ${props => props.theme.labelColorFocus};
    display:flex;
    flex-direction: row;
    align-items:center;
`;

export const MaxWidthRow = Styled.div`
  min-width: 296px;
  display:flex;
  flex:1 1;
  > * {
    flex: 1 1 250px;
    margin:4px;
  }
  width: 100%;
`;
